import { render, staticRenderFns } from "./StatusByGroup.vue?vue&type=template&id=02cf2460&scoped=true&"
import script from "./StatusByGroup.vue?vue&type=script&lang=js&"
export * from "./StatusByGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf2460",
  null
  
)

export default component.exports